import React, { Component, Fragment } from 'react';

import { AgGridReact } from 'ag-grid-react';
import { observer } from 'mobx-react';
import { PageHeader,Button,Badge,Tooltip} from 'antd';

const columnDefs = [
    { headerName: "Journal", field: "journalShortCode"},
    { headerName: "Article Title", field: "articleTitle"},
    { headerName: "Manuscript#", field: "manuscriptNo"},
    { headerName: "Article Type", field: "articleTypeName"},
    { headerName: "Doi", field: "doi"},
    { headerName: "Workflow", field: "workflowTriggerName"},
    //{ headerName: "Start Date", field: "startDate"},
    //{ headerName: "End Date", field: "expectedEndDate"},
   // { headerName: "Current Task", field: "currentTaskName"},
];

@observer
class ArticleInProductionList extends Component {

    constructor(props) {
        super(props);
    }

    onGridReady = (params) => {
        if (!params) {
            return;
        }

        this.gridApi = params.api;
        params.api.sizeColumnsToFit();

        this.props.articlesInProductionStore.fetchArticlesInProduction();
    }

    refresh = () => {
        this.props.articlesInProductionStore.fetchArticlesInProduction();
    }

    titleHeight = () => {
        const height = window.innerHeight/1.5;
        return { height: height };
    }

    render() {
        const store = this.props.articlesInProductionStore;
        const articles = store.articles;

        return (
            <Fragment>
                <PageHeader
                extra = {[
                        <Button key="refresh" onClick={this.refresh} icon = "reload"/>,
                        <Tooltip key="counts" placement="bottomLeft" title={store.rowCount}>
                            <Button icon= "info-circle" count={store.rowCount} ></Button>
                        </Tooltip>
                ]}>
                </PageHeader>
                {this.renderAgGrid()}
                {this.renderRowData(articles)}
            </Fragment>
        );
    }

    renderAgGrid() {

        const grid_classes = ["ag-theme-balham"].join(' ');

        if (!this.params) {
            return (
                <div className={grid_classes} style={this.titleHeight()}>
                    <AgGridReact 
                    columnDefs={columnDefs}
                     rowSelection={'single'} 
                     onGridReady={this.onGridReady} 
                     enableSorting={true}
                     enableFilter={true} 
                     enableColResize={true}
                     />
                </div>
            );
        }
    }

    renderRowData(articles) {
        if (this.gridApi) {
            this.gridApi.setRowData(articles);
        }
    }
}

export default ArticleInProductionList;
